import { createService, z } from '@betty/toolkit/api';
import { LimitsResponseSchema } from './LimitsService.schemas';

export default createService(
  {
    getLimits: {
      method: 'GET',
      url: '/limits',
      responseSchema: LimitsResponseSchema,
    },
    updateLimits: {
      method: 'PUT',
      url: '/limits',
      responseSchema: z
        .object({
          errorCode: z.string().optional(),
        })
        .optional(),
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
